// extracted by mini-css-extract-plugin
export default {"active":"Navbar_active__zz1Pj","default":"Navbar_default__EArS5"};